import React, { useReducer, useContext, useLayoutEffect } from 'react';
import Cookies from 'js-cookie';
import PricingContext from '../../context/pricing';
import pricingReducer from '../../reducers/pricing';
import { START_FREE_PACKAGES } from '../../constants/pricing/config';
import { getUrlParameter, isValidPricingCookie } from '../../utils/pricing';
import { setPricingState, setActiveTab } from '../../actions/pricing';
import Header from './Header';
import EmailPlans from './EmailPlans';
import MarketingPlans from './MarketingPlans';
import PlanComparison from './PlanComparison';
import FrequentlyAsked from './FrequentlyAsked';
import FooterCallout from './FooterCallout';
import FixedFooter from './FixedFooter';
import FixedFooterButtons from './FixedFooterButtons';

const Pricing = ({ isFullPricing, sgPricingVersion }) => {
  const initialState = useContext(PricingContext);
  const [state, dispatch] = useReducer(pricingReducer, initialState);

  useLayoutEffect(() => {
    /**
     * Maybe restore state, then:
     * - Reset addon state to default.
     * - Reset packages if they match START_FREE_PACKAGES constant
     */
    const signUpVals = Cookies.getJSON('tneSignUpVals');
    if (isValidPricingCookie(signUpVals)) {
      delete signUpVals.addons;
      if (
        signUpVals.packages.e === START_FREE_PACKAGES.e &&
        signUpVals.packages.mc === START_FREE_PACKAGES.mc
      )
        delete signUpVals.packages;

      setPricingState(signUpVals, dispatch);
    }

    /**
     * Check for URL param to default to a product tab.
     * EX: ?product=mc will load the App with the MC tab selected.
     */
    const sgProduct = getUrlParameter('sg_product') || false;
    if (sgProduct) {
      const activeTab = ['e', 'mc'].includes(sgProduct) ? sgProduct : 'e';
      setActiveTab(activeTab, dispatch);
    }
  }, []);

  return (
    <PricingContext.Provider
      value={{ state, dispatch, sgPricingVersion, isFullPricing }}
    >
      <Header />
      <EmailPlans />
      <MarketingPlans />
      {isFullPricing && (
        <>
          <PlanComparison />
          <FrequentlyAsked />
          <FooterCallout />
        </>
      )}
      {/*<FixedFooter />*/}
      {/*<FixedFooterButtons />*/}
    </PricingContext.Provider>
  );
};

Pricing.defaultProps = {
  sgPricingVersion: 'a',
};

export default Pricing;
